module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_3250_Inactive@1x-bf4318e3f6fc634952bb464275dff267.png";